// extracted by mini-css-extract-plugin
module.exports = {"content":"_body_content__1W1wT"};